import { render, staticRenderFns } from "./CompanyContact.vue?vue&type=template&id=79aea8cd"
import script from "./CompanyContact.vue?vue&type=script&lang=js"
export * from "./CompanyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79aea8cd')) {
      api.createRecord('79aea8cd', component.options)
    } else {
      api.reload('79aea8cd', component.options)
    }
    module.hot.accept("./CompanyContact.vue?vue&type=template&id=79aea8cd", function () {
      api.rerender('79aea8cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/assets/CompanyContact.vue"
export default component.exports